/**
 * Oprávnění modulu Products (frontend zrcadlí backend `StationsPermissions`).
 * `read` = zobrazení agendy Stanice (menu, gate), `edit` = úpravy.
 */
export const PRODUCTS_STATIONS = 'products.stations';

/** Oprávnění agendy Trasy autobusů (zrcadlí backend `StationsPermissions.StationChains`). */
export const PRODUCTS_STATION_CHAINS = 'products.station-chains';
